import api from './api';

/**
 * User-facing AI features (under /api/v1/**, so responses are wrapped in ApiResponse and we
 * unwrap `response.data.data`).
 */
const aiService = {
  /**
   * Generate a title & description from a short brief, tuned to the content type and target
   * platforms. Gated server-side by the ai_metadata_generator feature flag + a per-tier quota.
   * @returns {Promise<{title:string, description:string, model:string, tokensUsed:number}>}
   */
  generateContentMetadata: async ({ brief, contentType, platforms }) => {
    const res = await api.post('/api/v1/ai/generate-metadata', { brief, contentType, platforms });
    return res.data.data;
  },
};

export default aiService;
